import { FormControl, FormControlLabel, FormGroup, Switch } from "@mui/material";

export default function MenuItemChecked({label, ...props}) {
    return (
        <FormControl component="fieldset" variant="standard">
            <FormGroup>
                <FormControlLabel
                    control={
                        <Switch name="gilad" {...props} />
                    }
                    label={label}
                />
            </FormGroup>
        </FormControl>
    )
}